var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-qa": "guest-section-form" } },
    [
      _c(
        "div",
        { staticClass: "gfu-1of1 gfu-1of2--m _flexcol _gap-3" },
        [
          _c("text-field", {
            staticClass: "_mt-0",
            attrs: {
              "display-name": _vm.Resources.Checkout.EmailFieldLabel,
              name: "model.unauthenticatedUser.email",
              "read-only": _vm.readOnly,
              description: _vm.Resources.Checkout.EmailFieldDescription,
              "data-qa": "guest-checkout:Email",
            },
            model: {
              value: _vm.model.email,
              callback: function ($$v) {
                _vm.$set(_vm.model, "email", $$v)
              },
              expression: "model.email",
            },
          }),
          _vm._v(" "),
          _c("text-field", {
            staticClass: "_mt-0",
            attrs: {
              "display-name":
                _vm.Resources.Checkout.EmailConfirmationFieldLabel,
              name: "model.unauthenticatedUser.confirmationEmail",
              "read-only": _vm.readOnly,
              description:
                _vm.Resources.Checkout.EmailConfirmationFieldDescription,
              "data-qa": "guest-checkout:ConfirmationEmail",
            },
            model: {
              value: _vm.model.confirmationEmail,
              callback: function ($$v) {
                _vm.$set(_vm.model, "confirmationEmail", $$v)
              },
              expression: "model.confirmationEmail",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "checkbox-field",
        {
          staticClass: "_mb-0 _mt-3",
          attrs: {
            inline: true,
            condensed: true,
            "read-only": _vm.readOnly,
            type: "checkbox",
            "data-qa": "guest-checkout:CreateAccountCheckbox",
          },
          model: {
            value: _vm.model.createAccount,
            callback: function ($$v) {
              _vm.$set(_vm.model, "createAccount", $$v)
            },
            expression: "model.createAccount",
          },
        },
        [
          _c(
            "localize",
            {
              attrs: {
                resource: _vm.Resources.Checkout.CreateAccountCheckboxLabel,
              },
            },
            [
              _c("span", { attrs: { "format-key": "0" } }, [
                _vm._v(_vm._s(_vm.platformName)),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }